var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetch,"theme":"default"}},[_c('div',{staticClass:"project-page"},[_c('Blocks',{ref:"blocks",attrs:{"blocks":_vm.config,"custom-components":_vm.customComponents}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }